import { Contact } from "@/components/landing/Contact";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageContact() {
  return (
    <>
      <SEO
        title="Contact"
        description="Contactez l'équipe Zafara / Whilsco-Digit — presse, partenariats, retours utilisateurs, candidatures vendeurs et livreurs indépendants."
        path="/contact"
      />
      <Contact />
      <PageFooterNav
        prev={{ to: "/whilsco-digit", label: "Whilsco-Digit" }}
        next={{ to: "/telecharger", label: "Télécharger l'app" }}
      />
    </>
  );
}
